import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { isValidContactPhone } from "../../utils/flightSearchDetails";
import PhoneCountryInput from "./PhoneCountryInput";
import "./FlightSearchDetailsModal.css";

const OUTSIDE_CLICKS_TO_SHOW_CLOSE = 4;

const FlightSearchDetailsModal = ({
  open,
  onContinue,
  onDismiss,
  submitting = false,
  initialPhone = "",
  title = "Get the best flight deals",
  description = "Enter your phone number and our agents will get the lowest price for you.",
  submitLabel = "Continue",
  allowDismiss = true,
}) => {
  const [phone, setPhone] = useState(initialPhone);
  const [error, setError] = useState("");
  const [outsideClickCount, setOutsideClickCount] = useState(0);

  useEffect(() => {
    if (!open) return;
    setPhone(initialPhone || "");
    setError("");
    setOutsideClickCount(0);
  }, [open, initialPhone]);

  if (!open) return null;

  const handlePhoneChange = (fullPhone) => {
    setPhone(fullPhone);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedPhone = phone.trim();

    if (!trimmedPhone || !isValidContactPhone(trimmedPhone)) {
      setError("Please enter a valid phone number");
      return;
    }

    setError("");
    onContinue({
      phone: trimmedPhone,
    });
  };

  const handleBackdropClick = () => {
    if (!allowDismiss) return;
    setOutsideClickCount((count) => Math.min(count + 1, OUTSIDE_CLICKS_TO_SHOW_CLOSE));
  };

  const handleClose = () => {
    setOutsideClickCount(0);
    onDismiss?.();
  };

  const showClose = allowDismiss && outsideClickCount >= OUTSIDE_CLICKS_TO_SHOW_CLOSE;

  return (
    <div
      className="flight-search-details-modal-backdrop"
      onClick={handleBackdropClick}
    >
      <div
        className="flight-search-details-modal"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={`flight-search-details-modal-header${title ? "" : " is-empty"}`}>
          {title ? <h3>{title}</h3> : null}
        </div>
        {showClose ? (
          <button
            type="button"
            className="flight-search-details-modal-close"
            onClick={handleClose}
            aria-label="Close"
          >
            <X />
          </button>
        ) : null}

        <form onSubmit={handleSubmit} className="flight-search-details-modal-body">
          {description ? (
            <p className="flight-search-details-modal-text">
              <span>{description}</span>
            </p>
          ) : null}

          {error && <div className="flight-search-details-modal-error">{error}</div>}

          <div className="flight-search-details-modal-field">
            <label htmlFor="flight-search-phone">Phone Number</label>
            <PhoneCountryInput
              id="flight-search-phone"
              value={phone}
              onChange={handlePhoneChange}
              disabled={submitting}
            />
          </div>

          <button
            type="submit"
            className="flight-search-details-modal-submit"
            disabled={submitting}
          >
            {submitting ? "Continuing..." : submitLabel}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FlightSearchDetailsModal;
